import { render } from "./ProductLists.vue?vue&type=template&id=7a6faf13"
import script from "./ProductLists.vue?vue&type=script&lang=js"
export * from "./ProductLists.vue?vue&type=script&lang=js"
script.render = render

export default script